import type { Sex } from "@ferrivia/api-contract";
import { useTranslation } from "@ferrivia/i18n";
import { ChoiceRow } from "../../components/ChoiceRow";
import { StepLayout } from "../components/StepLayout";
import s from "./SexStep.module.css";

export interface SexStepProps {
  value: Sex | null;
  onAnswer: (sex: Sex) => void;
}

/** Single tap answers it, so there is no Continue button — see OnboardingFlow. */
export function SexStep({ value, onAnswer }: SexStepProps) {
  const { t } = useTranslation("client");

  const options: { value: Sex; label: string }[] = [
    { value: "female", label: t("onboarding.sex.options.female", "Nainen") },
    { value: "male", label: t("onboarding.sex.options.male", "Mies") },
  ];

  return (
    <StepLayout
      title={t("onboarding.sex.title", "Opitaan tuntemaan sinut")}
      // Deliberately NOT the prototype's "vaikuttaa mm. viitearvoihisi": that
      // promises the app will apply reference ranges to a client's values,
      // which is exactly what it must never do — and under MDR Art. 2(12) a
      // promotional statement is constitutive of intended purpose
      // (REQ-MDR-004). This says why we ask without claiming what we compute.
      subtitle={t("onboarding.sex.subtitle", "Naisten ja miesten raudan tarve on erilainen.")}
    >
      <div role="radiogroup" aria-label={t("onboarding.sex.legend", "Biologinen sukupuoli")} className={s.options}>
        {options.map((option) => (
          <ChoiceRow
            key={option.value}
            role="radio"
            selected={value === option.value}
            onSelect={() => onAnswer(option.value)}
          >
            {option.label}
          </ChoiceRow>
        ))}
      </div>
    </StepLayout>
  );
}
